import React from "react";
import { withNavBars } from "../../HOCs";
import Receipt from "./receipt";

class ReceiptParent extends React.Component {
    render() {
        return <Receipt />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(ReceiptParent, props);
